const SUB_STATUSES = {
  DEACTIVATION_PENDING_BILLING_CYCLE: 'deactivation_pending_billing_cycle',
  DEACTIVATION_PENDING_CONTRACT: 'deactivation_pending_contract',
  DELINQUENT_PAYMENT: 'delinquent_payment',
  FREE_MONTH_CONCESSION_PENDING: 'free_month_concession_pending',
  LESS_THAN_TEN_BILLED: 'less_than_ten_billed',
  OVERAGE_APPLIED: 'overage_applied',
  PAUSE_PENDING: 'pause_pending',
  TEN_OR_MORE_BILLED: 'ten_or_more_billed',
  TIER_CHANGE_PENDING: 'tier_change_pending',
  ZERO_BILLED: 'zero_billed',
} as const;

const UPDATED_SUB_STATUSES = (({
  DEACTIVATION_PENDING_BILLING_CYCLE,
  FREE_MONTH_CONCESSION_PENDING,
  TIER_CHANGE_PENDING,
}) => ({ DEACTIVATION_PENDING_BILLING_CYCLE, FREE_MONTH_CONCESSION_PENDING, TIER_CHANGE_PENDING }))(
  SUB_STATUSES
);

export { UPDATED_SUB_STATUSES };

export default SUB_STATUSES;
